import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { DailyDosingRateTanksResponse, DosingGoalResponse, SaveDosingRatesRequest } from '../models/dosing.model';
import { NutritionalFact } from '../models/dosing.model';
import { DosingRates } from '../models/dosing.model'; 
@Injectable({
  providedIn: 'root',
})
export class DosingService {

  baseUrl = environment.baseUrl; 
  
  constructor(private http: HttpClient) {}

  getDosingBalance(): Observable<DosingGoalResponse[]> {
    var dosingGoalUrl = `${this.baseUrl}dosingrates/GetDailyDosingGoals`;
    var url = `${dosingGoalUrl}`;
    return this.http.get<DosingGoalResponse[]>(url);
  }
  
  getNutritionalFacts(siteId:number): Observable<NutritionalFact[]> {
    var nutritionalFactsUrl = `${this.baseUrl}dosingrates/GetDailyDosingNutritionalFacts?siteId=${siteId}`;  
    var url = `${nutritionalFactsUrl}`;
    return this.http.get<NutritionalFact[]>(url);
  }

  getDosingRatee(siteId:number): Observable<DosingRates> {
    var nutritionalFactsUrl = `${this.baseUrl}dosingrates/GetSiteDailyDosingRates?siteId=${siteId}`;  
    var url = `${nutritionalFactsUrl}`;
    return this.http.get<DosingRates>(url);
  }
    
  getSiteDailyDosingVolumes(siteId: number) {
    const url = `${this.baseUrl}dosingrates/GetSiteDailyDosingVolumes?siteId=${siteId}`;
    return this.http.get<any>(url, {
      headers: { Accept: 'text/plain' }
    });
  }

  getDailyDosingRateTanks(siteId: number): Observable<DailyDosingRateTanksResponse[]> {
    const url = `${this.baseUrl}dosingrates/GetDailyDosingRateTanks?siteId=${siteId}`;
    return this.http.get<DailyDosingRateTanksResponse[]>(url);
  }

  saveDosingRates(payload: SaveDosingRatesRequest): Observable<boolean> {
    const url = `${this.baseUrl}dosingrates`;
    return this.http.post<boolean>(url, payload);
  }
}
